import clsx from 'clsx';
import React from 'react';

import { FilterBoxTypes } from '@/src/components/common/FilterBox/V2/FilterBox';
import {
  useMyPortfolio,
  getFilterOption,
} from '@/src/components/myTasks2/components/Tabs/MyPortfolio/store/myPortfolio.store';

import CheckboxHeaderItem from './CheckboxHeaderItem';
import DateRangeHeaderItem from './DateRangeHeaderItem';
import TextContainingHeaderItem from './TextContainingHeaderItem';

import { ColumnOption } from '../../Table/Table';

type FiltertableHeaderItemProps = {
  column: ColumnOption;
  disableFilters?: boolean;
  bottomContent?: React.ReactNode;
  className?: string;
};

const headerItemsComponentMap = {
  [FilterBoxTypes.Checkbox]: CheckboxHeaderItem,
  [FilterBoxTypes.DateRange]: DateRangeHeaderItem,
  [FilterBoxTypes.TextContaining]: TextContainingHeaderItem,
};

const FiltertableHeaderItem = ({
  column,
  className = null,
  bottomContent = null,
  disableFilters = false,
}: FiltertableHeaderItemProps) => {
  const { filterOptions } = useMyPortfolio();

  if (!filterOptions) {
    return <div className={clsx('columnItemContainer', className)}>{column.title}</div>;
  }

  const filterOption = getFilterOption(filterOptions, column.column.name);

  // Determine the component to render based on filterOption.type
  let filterComponent: React.ReactNode = null;

  switch (filterOption.type) {
    case FilterBoxTypes.Checkbox:
      filterComponent = (
        <CheckboxHeaderItem
          column={column}
          filterOption={filterOption}
          bottomContent={bottomContent}
          disableFilters={disableFilters}
        />
      );
      break; // Important: add break statements to prevent fallthrough
    case FilterBoxTypes.DateRange:
      filterComponent = <DateRangeHeaderItem column={column} filterOption={filterOption} />;
      break;
    case FilterBoxTypes.TextContaining:
      filterComponent = <TextContainingHeaderItem column={column} filterOption={filterOption} />;
      break;
    default:
      // Handle unsupported types, e.g., by throwing an error or returning a default component
      break;
  }

  return <div className={clsx('columnItemContainer', className)}>{filterComponent}</div>;
};

export default FiltertableHeaderItem;
